import React from "react";

const bandStyles = {
  green: { color: "#059851", bg: "#ECFDF3", dot: "#12B76A" },
  amber: { color: "#B77406", bg: "#FEF6E7", dot: "#F5A623" },
  red:   { color: "#B42318", bg: "#FEF3F2", dot: "#F04438" },
};

export const HealthPill = ({ score, band, testId, size = "sm" }) => {
  const s = bandStyles[band] || bandStyles.amber;
  const sizing = size === "lg"
    ? "text-sm px-3 py-1 gap-2"
    : "text-xs px-2.5 py-0.5 gap-1.5";
  const dotSize = size === "lg" ? 8 : 6;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full font-bold tabular-nums ${sizing}`}
      style={{ color: s.color, background: s.bg }}
    >
      <span
        className="inline-block rounded-full"
        style={{ width: dotSize, height: dotSize, background: s.dot }}
      />
      {score}
    </span>
  );
};

export const StatusPill = ({ band = "amber", children, testId }) => {
  const s = bandStyles[band] || bandStyles.amber;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider"
      style={{ color: s.color, background: s.bg }}
    >
      {children}
    </span>
  );
};

export default HealthPill;
